import { gql } from '@apollo/client'

export const CHATBOT_REPORTS_ELIGIBLE = gql`
  query chatbotReportsEligible {
    uiFlags {
      chatbotReportsEligible
    }
  }
`
